export const MENUS = [
  { title: "홈", id: "synopsys" },
  { title: "무비 클립", id: "trailer" },
  { title: "뉴스", id: "news" },
  { title: "굿즈", id: "goods" },
];
